export default {
      id: "icon-report-usage",
      viewBox: "-1 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-report",
      toString: function () {
        return this.url;
      }
    }